import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AIONZ_TOOLTIP_DATA } from '@aionzdev/design-system';
import {
  SupplierResponseEntry,
  SupplierResponsesSummary
} from '../../../interfaces/supplier-responses-summary';

/**
 * Tooltip do chip de fornecedores do card: quem respondeu e quem ainda não,
 * sem precisar abrir o mapa de cotação.
 */
@Component({
  selector: 'aionz-supplier-responses-tooltip',
  imports: [MatIconModule],
  templateUrl: './supplier-responses-tooltip.component.html',
  styleUrl: './supplier-responses-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupplierResponsesTooltipComponent {
  protected readonly data = inject(AIONZ_TOOLTIP_DATA) as SupplierResponsesSummary;

  protected readonly pending = computed<SupplierResponseEntry[]>(() =>
    this.data.suppliers.filter(s => !s.responded)
  );

  protected readonly responded = computed<SupplierResponseEntry[]>(() =>
    this.data.suppliers.filter(s => s.responded)
  );

  protected readonly progress = computed(() =>
    this.data.total > 0 ? Math.round((this.data.responded / this.data.total) * 100) : 0
  );

  protected readonly allResponded = computed(
    () => this.data.total > 0 && this.data.responded >= this.data.total
  );

  protected readonly summaryLabel = computed(() => {
    const { total, responded, inQuotation } = this.data;
    if (!inQuotation) {
      return `${total} ${total === 1 ? 'fornecedor' : 'fornecedores'} no pedido`;
    }
    if (this.allResponded()) {
      return total === 1 ? 'O fornecedor respondeu' : `Todos os ${total} responderam`;
    }
    return `${responded} de ${total} ${responded === 1 ? 'respondeu' : 'responderam'}`;
  });
}
